var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBalcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m421 165c0-90.980469-74.019531-165-165-165s-165 74.019531-165 165v106h-91v30h31v211h450c0-23.285156 0-190.339844 0-211h31v-30h-91zm-60 257v-121h30v121zm-210-121v121h-30v-121zm105-211c14.921875 35.832031 40.582031 67.285156 75 89.304688v91.695312h-150v-91.695312c32.6875-20.910157 59.292969-51.582032 75-89.304688zm-75 211h30v121h-30zm60 0h30v121h-30zm60 0h30v121h-30zm60-30v-75.984375c9.691406 4.046875 19.722656 7.324219 30 9.757813v66.226562zm30-106v8.808594c-65.445312-18.34375-112.785156-74.964844-119.238281-142.882813 67.039062 7.832031 119.238281 64.964844 119.238281 134.074219zm-150.761719-134.074219c-6.453125 67.917969-53.792969 124.535157-119.238281 142.882813v-8.808594c0-69.109375 52.199219-126.242188 119.238281-134.074219zm-119.238281 173.847657c10.277344-2.433594 20.308594-5.710938 30-9.757813v75.984375h-30zm-60 96.226562h30v121h-30zm390 181h-390v-30h390zm0-60h-30v-121h30zm0 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalcon);
export default __webpack_public_path__ + "static/media/balcon.b93c80f9.svg";
export { ForwardRef as ReactComponent };